import { Inject, Injectable, LOCALE_ID, Optional } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocalizedTextService {
  // eslint-disable-next-line @angular-eslint/prefer-inject
  constructor(@Optional() @Inject(LOCALE_ID) private readonly localeId: string = 'en') {}

  getLocalizedText(english?: string | null, french?: string | null): string {
    return (this.isFrench() ? french : english) ?? '';
  }

  private isFrench(): boolean {
    return this.localeId.toLowerCase().startsWith('fr');
  }
}
